import React from 'react'
import PropTypes from 'prop-types'
import CurrencyItem from 'components/CurrencyItem'
import TinyLineChart from 'components/TinyLineChart'
import { numberPercentFormatter } from 'utils/formatters'

export const FeaturedCryptoCurrencyCard = ({ currency, mode }) => {
	return <div className='u-margin-horizontal-small'>
		<div className='c-featured-card u-margin-bottom'>
			<div className='c-featured-card__header u-margin-bottom-small'>
				<CurrencyItem currency={currency} mode={mode} />
				<div className='c-featured-card__period u-text--normal u-margin-top-small'>24h</div>
			</div>
			<div className='c-featured-card__rate u-padding-right-large u-text--cornflower u-text--large'>
				<span className='c-featured-card__rate__base'>{parseFloat(currency.conversion_value).toFixed(2)} BGN</span>
				<span className='c-featured-card__rate__growth--crypto c-featured-card__rate__growth--crypto--up'>{ numberPercentFormatter(currency.daily_diff) }</span>
			</div>
			<div className='c-featured-card__graph'>
				<TinyLineChart abbr={currency.abbreviature} history={{ data: currency.last_24h_values }} mode={mode} filter='day' />
			</div>
		</div>
	</div>
}

FeaturedCryptoCurrencyCard.propTypes = {
	currency: PropTypes.shape({
		flag: PropTypes.string,
		name: PropTypes.string,
		abbreviature: PropTypes.string,
		conversion_value: PropTypes.string,
		daily_diff: PropTypes.string,
		last_24h_values: PropTypes.arrayOf(PropTypes.shape({
			date: PropTypes.string,
			conversion_value: PropTypes.string
		}))
	})
}

export default FeaturedCryptoCurrencyCard
